import Countdown from "react-countdown"
import { SaleEndTime, SaleStartTime } from "../../../../../../hooks/useReadPresale";

 
function SaleCountdown() {
 
  const startTime = SaleStartTime() * 1000;
  const endTime = SaleEndTime() * 1000;
  const now = Date.now();
  // const time = now > startTime ? endTime : startTime;

  const time = 1753186387000;

    return ( 
       <>
      <Countdown
            date={time ? time : 1760826920000}
            renderer={props => (
                <>
                <div className="countdown-timer">
                  <div className="countdown-item w-100">
                    <span className="countdown-number" id="days">{props.days}</span>
                    <span className="countdown-label">Days</span>
                  </div>
                  <div className="countdown-item w-100">
                    <span className="countdown-number" id="hours">{props.hours}</span>
                    <span className="countdown-label">Hours</span>
                  </div>
                  <div className="countdown-item w-100">
                    <span className="countdown-number" id="minutes">{props.minutes}</span>
                    <span className="countdown-label">Minutes</span>
                  </div>
                  <div className="countdown-item w-100">
                    <span className="countdown-number" id="seconds">{props.seconds}</span>
                    <span className="countdown-label">Seconds</span>
                  </div>
                </div>
                </>
             )}
        /> 
    
     </> 
 ); 

}

export default SaleCountdown;